export const splitFullName = (word) => {
  return word?.split(" ");
};
